<template>
  <v-img
    class="site-logo"
    src="/img/cccfpd-logo-sm.png"
    width="20"
  />
</template>

<style scoped>
.site-logo {
  display: inline-block;
  flex-grow: 0;
  vertical-align: middle;
  transform: translateY(-2px);
}
</style>
